import { render, staticRenderFns } from "./ViUpdateAdhocfees.vue?vue&type=template&id=641ced2d"
import script from "./ViUpdateAdhocfees.vue?vue&type=script&lang=js"
export * from "./ViUpdateAdhocfees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports